import request from '@/utils/request'
export function getAppId(appId) {
  return request({
    method: 'POST',
    url: `/qyweixin/api/getAppId/${appId}`,
  })
}

// {
//   "agentId": "string",
//   "code": "string",
//   "corpId": "string",
//   "corpSecret": "string",
//   "url": "string"
// }
export function getQyWxConfig(data) {
  return request({
    method: 'POST',
    url: '/qyweixin/api/getQyWxConfig',
    data
  })
}

// export function weLogin() {
//   return request({
//     method: 'POST',
//     url: '/api/weLogin'
//   })
// }